import { gql, useMutation } from '@apollo/client';
import { NewsPost } from 'apollo/generated/types';
import { LocalizedEditNewsPostInput } from 'apollo/localizedTypes';

const EDIT_NEWS_POST = gql`
  mutation editNewsPost($input: EditNewsPostInput!) {
    editNewsPost(input: $input) {
      id
    }
  }
`;

const useEditNewsPostMutation = () => {
  return useMutation<{ editNewsPost: NewsPost }, { input: LocalizedEditNewsPostInput }>(
    EDIT_NEWS_POST,
    {}
  );
};
export default useEditNewsPostMutation;
